<div class="map-container">
    <div class="map-frame">
        <div id="map" leaflet [leafletLayers]="layers" [leafletFitBounds]="fitBounds">
        </div>
    </div>
</div>